// @flow
import React, { useState, useEffect, useRef, useCallback } from 'react';
import Debug from 'debug';
import PlayerItem from './PlayerItem';

const debug = Debug('amms:modules:tisPlayer:player');


type ProgressEvent = $ReadOnly<{|
    currentTime: number
|}>;

type Props = $ReadOnly<{
    playerRef: {},
    items: $ReadOnlyArray<{}>,

    playMessage: () => void,
    onStart?: () => void,
    onStop?: () => void
}>;
function Player({ playerRef, items, playMessage, onStart, onStop }: Props) {
    const [isPlaying, setIsPlaying] = useState();

    const play = useCallback(() => {
        debug('Play');
        setIsPlaying(true);
    }, []);
    const pause = useCallback(() => {
        debug('Pause');
        setIsPlaying(false);
    }, []);
    const stop = useCallback(() => {
        debug('Stop');
        setIsPlaying(false);
    }, []);

    const _playerRef = useRef({
        isPlaying,
        play,
        pause,
        stop
    });

    useEffect(() => {
        if(playerRef) {
            if(typeof playerRef === 'function') {
                playerRef(_playerRef.current);
            }
            else {
                playerRef.current = _playerRef.current;
            }
        }
    }, [playerRef, play, pause, stop]);

    useEffect(() => {
        if(isPlaying) {
            debug('Playing');
            _playerRef.current.isPlaying = true;

            if(onStart) {
                onStart();
            }
        }
        else if(!isPlaying) {
            debug('Not playing');
            _playerRef.current.isPlaying = false;

            if(onStop) {
                onStop();
            }
        }
    }, [isPlaying, onStart, onStop]);

    return (
        <React.Fragment>
            {items && items.map((item, index) => (
                <PlayerItem key={index} isPlaying={isPlaying} item={item} playMessage={playMessage} />
            ))}
        </React.Fragment>
    );
}

export default Player;